"use client"

import { useProductName } from "@/hooks/product_detail/useProductName"
import { useAppSelector } from "@/hooks/redux"
import { formatCurrencyUSD } from "@/utils/app/formatCurrencyUSD"
import { Form, Row, Typography } from "antd"
import ProductColors from "./ProductColors"
import ProductSizes from "./ProductSizes"
import ProductAddToCartButton from "./ProductAddToCartButton"
import ProductQuantity from "./ProductQuantity"
import { useCurrentPrice } from "@/hooks/product_detail/useCurrentPrice"
import BundleProducts from "./BundleProducts"
import ProductPromo from "./ProductPromo"
import { Discount, TypeStoreDetail } from "@/lib/redux/features/store/type"

const ProductPanel = ({ discountDetail, store }: { discountDetail: Discount | null, store: TypeStoreDetail }) => {
  const description = useAppSelector(state => state.product.design_detail.data.product_details.description)
  const productName = useProductName()
  const productNameSetting = store.product_name
  const productPriceSetting = store.product_price
  const { price, compare_at_price } = useCurrentPrice()

  return (
    <Form>
      <Row>
        <Typography.Title
          level={1}
          style={{
            marginBottom: 0,
            fontSize: `${productNameSetting?.size / 10}rem`,
            fontFamily: productNameSetting.font_name ? `${productNameSetting.font_name} !important` : undefined,
            color: productNameSetting.color,
            textAlign: productNameSetting.align || 'left',
            width: '100%',
            ...(productNameSetting.decorator === 'bold' ? {
              fontWeight: 'bold'
            } : {}),
            ...(productNameSetting.decorator === 'italic' ? {
              fontStyle: 'italic'
            } : {}),
            ...(productNameSetting.decorator === 'underline' ? {
              textDecoration: 'underline'
            } : {})
          }}
        >
          {productName}
        </Typography.Title>
      </Row>
      {!!compare_at_price && (
        <Row>
          <Typography.Title
            level={3}
            type='secondary'
            delete
            style={{
              margin: 0,
              fontSize: `${(productPriceSetting?.size - 5) / 10}rem`,
              fontFamily: productPriceSetting.font_name ? `${productNameSetting.font_name} !important` : undefined,
              // color: productPriceSetting.color,
              textAlign: productPriceSetting.align || 'left',
              width: '100%',
              ...(productPriceSetting.decorator === 'bold' ? {
                fontWeight: 'bold'
              } : {}),
              ...(productPriceSetting.decorator === 'italic' ? {
                fontStyle: 'italic'
              } : {}),
              ...(productPriceSetting.decorator === 'underline' ? {
                textDecoration: 'underline'
              } : {})
            }}
          >
            {formatCurrencyUSD.format(compare_at_price)}
          </Typography.Title>
        </Row>
      )}
      <Row>
        <Typography.Text
          style={{
            margin: 0,
            fontSize: `${productPriceSetting?.size / 10}rem`,
            fontFamily: productPriceSetting.font_name ? `${productNameSetting.font_name} !important` : undefined,
            color: productPriceSetting.color,
            textAlign: productPriceSetting.align || 'left',
            width: '100%',
            ...(productPriceSetting.decorator === 'bold' ? {
              fontWeight: 'bold'
            } : {}),
            ...(productPriceSetting.decorator === 'italic' ? {
              fontStyle: 'italic'
            } : {}),
            ...(productPriceSetting.decorator === 'underline' ? {
              textDecoration: 'underline'
            } : {})
          }}
        >
          {formatCurrencyUSD.format(price)}
        </Typography.Text>
      </Row>

      <ProductColors />
      <ProductSizes />
      <BundleProducts />
      <ProductQuantity />

      <Row style={{ marginBlock: '2rem' }}>
        <ProductAddToCartButton />
      </Row>
      
      <ProductPromo discountDetail={discountDetail} />

      <Row>
        <div className="ql-editor" dangerouslySetInnerHTML={{ __html: description }} />
      </Row>
    </Form>
  )
}

export default ProductPanel